import Chat from "../../../../assets/Chat";
import Clients from "../../../../assets/Clients";
import ImportClient from "../../../../assets/ImportClient";
import Dashboard from "../../../../assets/Dashboard";
import Pipeline from "../../../../assets/Pipeline";
import Files from "../../../../assets/Files";
import Team from "../../../../assets/Team";
import Templates from "../../../../assets/Templates";
import Disc from "../../../../assets/Disc";
import Setting from "../../../../assets/Setting";
import Reports from "../../../../assets/Reports";
import Payments from "../../../../assets/Payments";

const sidebarData = [
  {
    title: "Dashboard",
    icon: <Dashboard />,
    url: "/dashboard",
    activeUrl: ["/dashboard", "/"],
  },
  {
    title: "Files",
    icon: <Files />,
    url: "/files",
    activeUrl: ["/files", "/file"],
  },
  {
    title: "Payments",
    icon: <Payments />,
    url: "/payments_report",
    activeUrl: ["/payments_report"],
  },
  {
    title: "Chat",
    icon: <Chat />,
    url: "/communication",
    activeUrl: ["/communication"],
  },
  {
    title: "Team",
    icon: <Team />,
    url: "/team",
    activeUrl: ["/team"],
  },
  {
    title: "Clients",
    icon: <Clients />,
    url: "/clients",
    activeUrl: ["/clients", "/client_details"],
  },
  {
    title: "Import Client",
    icon: <ImportClient />,
    url: "/import_client",
    activeUrl: ["/import_client"],
  },
  {
    title: "Pipeline",
    icon: <Pipeline />,
    url: "/pipeline",
    activeUrl: ["/pipeline", "/task", "/task_detail"],
  },
  {
    title: "Templates",
    icon: <Templates />,
    activeUrl: ["/services", "/invoice"],
    children: [
      {
        title: "Services",
        icon: <Disc />,
        url: "/services",
        activeUrl: ["/services"],
      },
      {
        title: "Invoice",
        icon: <Disc />,
        url: "/invoice",
        activeUrl: ["/invoice"],
      },     
    ],
  },
  {
    title: "Reports",
    icon: <Reports />,
    activeUrl: ["/report/files"],
    children: [
      {
        title: "Files",
        icon: <Disc />,
        url: "/files_report",
        activeUrl: ["/files_report"],
      },
      {
        title: "Invoice",
        icon: <Disc />,
        url: "/invoice_report",
        activeUrl: ["/invoice_report"],
      },
      {
        title: "Signature",
        icon: <Disc />,
        url: "/signature_report",
        activeUrl: ["/signature_report"],
      },
    ],
  },
  {
    title: "Settings",
    icon: <Setting />,
    activeUrl: ["/tags"],
    children: [
      {
        title: "Tags",
        icon: <Disc />,
        url: "/tags",
        activeUrl: ["/tags"],
      },
      {
        title: "Banners",
        icon: <Disc />,
        url: "/banners",
        activeUrl: ["/banners"],
      },
      {
        title: "Site Settings",
        icon: <Disc />,
        url: "/settings",
        activeUrl: ["/settings"],
      },
    ],
  },
];

export default sidebarData;
